if (!customElements.get('discount-search')) {
  class DiscountSearch extends HTMLElement {
    constructor() {
      super();
      this.isProcessing = false; // 新增
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.submitBtn = this.querySelector('.js-search-submit');
      this.clearBtn = this.querySelector('.js-search-clear');
      // 获取结果容器
      this.resultContainer = this.querySelector('.js-result-txt');
      this.clearTimer = null; // 用于存储定时器 ID
      this.addListeners();
      this.init();
    }

    addListeners() {
      this.input.addEventListener('input', debounce(this.handleInput.bind(this)));
      //if (this.productTypeSelect) {
      //  this.productTypeSelect.addEventListener('change', this.handleProductTypeChange.bind(this));
      //}
      this.resetBtn.addEventListener('click', this.handleReset.bind(this));
      this.submitBtn.addEventListener('click', this.handleSubmit.bind(this));
      this.clearBtn.addEventListener('click', this.handleClear.bind(this));
     // this.submitBtn.addEventListener('click', (event) => this.handleSubmit(event));

    // 2. 绑定 keydown 事件监听
     this.input.addEventListener('keydown', this.handleInputKeydown.bind(this));
    }

    init() {
      if ((this.input.dataset.placeholderTwo || this.input.dataset.placeholderThree)
        && (this.input.dataset.placeholderPromptsMob === 'true' || theme.mediaMatches.md)) {
        //this.typeInPlaceholders();
      }
    }

/** 
    handleInput() {
        
      if (this.input.value.length > 0) {
        this.input.classList.add('search__input--dirty');
      } else {
        this.input.classList.remove('search__input--dirty');
      }

      console.log(this.input.value.trim())
    }
    handleReset() {
      this.input.classList.remove('search__input--dirty');
    }
*/

    handleInput() {
        const hasValue = this.input.value.length > 0;
        this.input.classList.toggle('search__input--dirty', hasValue);
        if (this.resetBtn) {
            this.resetBtn.hidden = !hasValue;
        }
        console.log(this.input.value.trim());
    }

    handleReset() {
        this.input.value = '';
        this.input.classList.remove('search__input--dirty');
        if (this.resetBtn) {
            this.resetBtn.hidden = true;
        }
        this.input.focus(); // 可选，将焦点放回输入框
    }

   async  handleInputKeydown(evt) {
      if (evt.key === 'Enter') {
        // 阻止默认行为：防止触发表单提交或页面刷新（如果输入框在 form 内）
        evt.preventDefault();

        // 获取当前输入的值
        const code = evt.target.value.trim() || '';
        if (!code) {
          //this.displayResult('请输入折扣码');
          return;
        }

        try {
          // 调用自身的方法
          await this.handleDiscount(code);
        } catch (error) {
          console.error('处理折扣信息失败:', error);
          // this.displayResult(`❌ 错误: ${error.message}`);
        }

      }
    }

    async handleSubmit(evt){
        //evt.preventDefault();
        console.log(this.input.value.trim())

        // 获取输入值
        const code = this.input.value.trim();
        if (!code) {
          //this.displayResult('请输入折扣码');
          this.updateResult('Please enter the discount code!', 'warning');
          return;
        }

        try {
          // 调用自身的方法
          await this.handleDiscount(code);
        } catch (error) {
          console.error('处理折扣信息失败:', error);
          // this.displayResult(`❌ 错误: ${error.message}`);
        }
    }


    async handleClear(evt){
        await this.removeDiscountCode();
        // 刷新购物车 UI
        await this.refreshCartDrawer();
         // 打开抽屉
        const drawer = document.querySelector('cart-drawer');
        if (drawer && !drawer.classList.contains('active')) {
            drawer.open();
        }
    }

    /**
     * Handles a change of product type
     * @param {object} evt - Event object.
     */
    handleProductTypeChange(evt) {
      this.productTypeInput.value = evt.detail.selectedValue;
    }




    async getInfoByCode(code,variantsInfo){
      // console.log("getInfoByCode")
      let res={};
      try {

          const response = await fetch('https://tsarbomba.com/apps/tsarbomba-app/queryDiscountInfoByCode', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({
              code: code,     // 数字ID
              variantsInfo:variantsInfo
          })
          });

          if (response.ok) {
          // 成功写入后，清除 Cookie 避免重复使用
          //document.cookie = 'im_ref=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
          // console.log(response.json())
          res = await response.json();
        
          //console.log(res.data)
          //data = response.json().data;
          }
      } catch (error) {
          res.success= false
          res.error="error"
      }
      return res;

    }

    // ---------- 修改 handleDiscount：添加赠品 → 应用折扣 → 更新 UI ----------
    async handleDiscount(code) {
        // 防止重复提交
        if (this.isProcessing) {
            console.warn('正在处理中，请勿重复提交');
            return;
        }
        
        this.isProcessing = true;
        this.updateResult('Processing...', 'info',10000);

        try {
            const cartItems = await this.getCart();
            if (cartItems.length === 0) {
                console.warn('购物车为空');
                return;
            }

            const variantsInfo = cartItems.map(item => ({
                variantId: item.variant_id.toString(),
                productId: item.product_id.toString(),
                quantity: item.quantity
            }));

            const res = await this.getInfoByCode(code, variantsInfo);
            if (!res.success || !res.data.isDiscount) {
                console.warn('折扣不可用或无效');
                this.updateResult('Unavailable Or Invalid', 'error',5000);
                return;
            }else{
              this.updateResult('Applying discount code...', 'success',5000);
            }
            

            const addlines = res.data.addlines;
            if (addlines.length > 0) {
                const sorted = [...addlines].sort((a, b) => (a.price ?? Infinity) - (b.price ?? Infinity));
                const cheapest = sorted[0];
                const items = [{
                    id: parseInt(cheapest.addVariantId),
                    quantity: cheapest.quantity || 1
                }];
                await this.addCart(items);
            }

            // 应用折扣码（如果已注释则跳过）
             await this.applyDiscountCode(code);

            // 刷新购物车 UI
            await this.refreshCartDrawer();
            await this.updateCartQuantity();

            // 打开抽屉
            const drawer = document.querySelector('cart-drawer');
            if (drawer && !drawer.classList.contains('active')) {
                drawer.open();
            }
        } catch (error) {
            console.error('处理折扣失败:', error);
            this.updateResult('An error occurred during the processing!', 'error',5000);
        } finally {
            // 无论成功或失败，都释放锁
            this.isProcessing = false;
        }
    }

    async getCart() {
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js');
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const cart = await response.json();
            console.log('购物车商品列表:', cart.items);
            return cart.items;
        } catch (error) {
            console.error('获取购物车失败:', error);
            return []; // 返回空数组，调用方需自行判断
        }
    }

    // ---------- 修改 addCart：只负责添加商品，返回 cart ----------
    async addCart(items) {
      try {
          const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items })
          });
          const cart = await response.json();
          console.log('✅ 商品已添加', cart);
          return cart;   // 返回 cart 供后续使用
      } catch (error) {
          console.error('❌ 添加失败:', error);
          throw error;
      }
    }


    // ---------- 新增：应用折扣码 ----------
    async applyDiscountCode(code) {
      try {
          const response = await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: code })
          });
          const cart = await response.json();
          console.log('✅ 折扣码已应用', cart);
          return cart;
      } catch (error) {
          console.error('❌ 应用折扣码失败:', error);
          throw error;
      }
    }

    // ---------- 移除折扣码 ----------
    async removeDiscountCode() {
        try {
            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: '' })
            });
            const cart = await response.json();
            console.log('✅ 折扣码已移除', cart);
            return cart;
        } catch (error) {
            console.error('❌ 移除折扣码失败:', error);
            throw error;
        }
    }

    async refreshCartDrawer() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.refresh === 'function') {
          await drawer.refresh();
          console.log('✅ 购物车已刷新（通过 cart-drawer.refresh）');
      } else {
          console.warn('cart-drawer 未找到或不支持 refresh，尝试降级方案');
          // 降级：手动触发刷新事件（如果存在）
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      }
    }

    async updateCartQuantity() {
      try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          const itemCount = cart.item_count;

          // 更新抽屉头部数量
          const numEl = document.getElementById('cart_drawer_num');
          if (numEl) numEl.textContent = itemCount;

          // 更新购物车图标数量徽章（如果存在）
          /*
          const badge = document.querySelector('.cart-count-bubble span:first-child');
          if (badge) badge.textContent = itemCount;
          const badgeText = document.querySelector('.cart-count-bubble span.visually-hidden');
          if (badgeText) badgeText.textContent = `${itemCount} items`;
          */
          console.log('✅ 购物车数量已手动更新');
      } catch (error) {
          console.warn('手动更新购物车数量失败:', error);
      }
    }

    /**
     * 更新结果显示
     * @param {string} message - 要显示的消息
     * @param {string} type - 消息类型: 'info' | 'success' | 'error' | 'warning'
     */
      updateResult(message, type = 'info', autoClearDelay = 5000) {
        if (!this.resultContainer) return;

        // 清除之前的定时器（防止多个定时器叠加）
        if (this.clearTimer) {
            clearTimeout(this.clearTimer);
            this.clearTimer = null;
        }

        // 清空容器并插入新内容
        this.resultContainer.innerHTML = message;

        // 移除所有样式类
        this.resultContainer.classList.remove('result-info', 'result-success', 'result-error', 'result-warning');
        
        // 根据类型添加样式类（需要提前定义 CSS 样式）
        this.resultContainer.classList.add(`result-${type}`);

        // 如果设置了自动清除延迟（且 > 0），则启动定时器
        if (autoClearDelay > 0) {
            this.clearTimer = setTimeout(() => {
                this.resultContainer.innerHTML = '';
                this.resultContainer.className = ''; // 移除所有样式
                this.clearTimer = null;
            }, autoClearDelay);
        }
        
    }


  }
  customElements.define('discount-search', DiscountSearch);
}